import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Vuelidate from "vuelidate";
import VueCookies from "vue-cookies";
import "./permission.js";
import "../src/assets/css/newStyle.css";
import "../src/assets/css/style.css";
import "../src/assets/css/normalize.css";
import "../src/assets/css/typography.css";
import BlueButton from "../src/components/commonComponents/BlueButton.vue";
import OutlineButton from "./components/commonComponents/OutlineButton.vue";
import OpportunityCard from "@/components/commonComponents/Opportunity-card.vue";
import vue3GoogleLogin from "vue3-google-login";
import PosthogPlugin from '../plugins/posthog'
import VueMeta from "vue-meta";

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VueCookies);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(PosthogPlugin)

Vue.component("BlueButton", BlueButton);
Vue.component("OutlineButton", OutlineButton);
Vue.component("OpportunityCard", OpportunityCard);
Vue.config.productionTip = false;
let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation();

      const { handler, exclude } = binding.value || {};
      if (!handler) {
        console.error("Handler not provided in v-closable directive.");
        return;
      }

      // Check for excluded elements
      let clickedOnExcludedEl = false;
      exclude?.forEach((refName) => {
        if (!clickedOnExcludedEl) {
          let excludedEl = vnode.context.$refs[refName];
          excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;

          if (excludedEl?.contains(e.target)) {
            clickedOnExcludedEl = true;
          }
        }
      });

      // If clicked outside the element and not on excluded elements
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        if (typeof handler === "function") {
          // If the handler is a direct function, call it
          handler(e);
        } else if (typeof vnode.context[handler] === "function") {
          // If the handler is a method name, call it on the component context
          vnode.context[handler](e);
        } else {
          console.error(
            `Handler "${handler}" is not a function or method in the component context.`,
          );
        }
      }
    };

    document.addEventListener("click", handleOutsideClick);
  },
  unbind() {
    document.removeEventListener("click", handleOutsideClick);
  },
});
Vue.use(vue3GoogleLogin, {
  clientId: process.env.VUE_APP_CLIENT_ID,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
